"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ExclamationIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ExclamationIcon, _React$PureComponent);

  function ExclamationIcon() {
    _classCallCheck(this, ExclamationIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExclamationIcon).apply(this, arguments));
  }

  _createClass(ExclamationIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className"]);
      /* eslint-disable max-len */


      var svg = {
        small: {
          // TODO: path and viewBox are not the right ones, it's a temporary
          // version based on the medium one shrinked to 8x8 with CSS
          // need to pick the exact unique shape once provided by the design team
          // #ENG-162166
          // viewBox: '0 0 8 8',
          viewBox: '0 0 12 12',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M6,0 L6,0 C6.97509431,-1.79121919e-16 7.76556444,0.790470124 7.76556444,1.76556444 C7.76556444,1.83877361 7.76101101,1.91191191 7.75193053,1.98455575 L7.10949566,7.12403473 C7.04694206,7.62446356 6.62154105,8 6.11721778,8 L5.88278222,8 C5.37845895,8 4.95305794,7.62446356 4.89050434,7.12403473 L4.24806947,1.98455575 C4.1271239,1.01699124 4.81344417,0.134579471 5.78100868,0.0136339063 C5.85365253,0.00455342596 5.92679083,1.34483068e-17 6,0 Z"
          }), _react.default.createElement("rect", {
            fill: color,
            x: "4.80000019",
            y: "9.39999962",
            width: "2.4000001",
            height: "2.5999999",
            rx: "1.20000005"
          }))
        },
        medium: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M6,0 L6,0 C6.97509431,-1.79121919e-16 7.76556444,0.790470124 7.76556444,1.76556444 C7.76556444,1.83877361 7.76101101,1.91191191 7.75193053,1.98455575 L7.10949566,7.12403473 C7.04694206,7.62446356 6.62154105,8 6.11721778,8 L5.88278222,8 C5.37845895,8 4.95305794,7.62446356 4.89050434,7.12403473 L4.24806947,1.98455575 C4.1271239,1.01699124 4.81344417,0.134579471 5.78100868,0.0136339063 C5.85365253,0.00455342596 5.92679083,1.34483068e-17 6,0 Z"
          }), _react.default.createElement("rect", {
            fill: color,
            x: "4.80000019",
            y: "9.39999962",
            width: "2.4000001",
            height: "2.5999999",
            rx: "1.20000005"
          }))
        }
      }[size];
      /* eslint-enable max-len */

      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'exclamation-icon'),
        viewBox: svg.viewBox,
        size: size
      }, props), svg.path);
    }
  }]);

  return ExclamationIcon;
}(_react.default.PureComponent);

exports.default = ExclamationIcon;
ExclamationIcon.defaultProps = {
  size: 'medium',
  color: 'inherit'
};
ExclamationIcon.propTypes = {
  size: _propTypes.default.oneOf(['medium', 'small']),
  className: _propTypes.default.string,
  color: _propTypes.default.string
};